<template>
<div class="message">
  <div class="message-tag">
    <!--公告和消息两个路由的name是notice和message-->
    <div class="tab-item"
      v-for="(item,index) in tabsComputed"
         :key="index"
         :class="{on: item.tabName == $route.name}"
         @click="tabHandle(item)"
    >
      <span class="label">{{item.label}}</span>
      <span
        v-if="item.count"
        :style="getCountStyle(item)"
        class="count"
      >{{item.count}}</span>
    </div>
  </div>
  <div class="message-outer">
    <div class="message-inner">
      <router-view
        @send-msg-count="sendMsgCount"
        @send-PopUp-count="sendPopUpCount"
        @readall-msg="readallMsg"
        @readall-popUp="readallPopUp"
        @refresh-popUp-count="refreshPopUpCount"
      ></router-view>
    </div>
  </div>
</div>
</template>

<script>
import { colorRgba } from "@/utils";
import { mapGetters } from 'vuex'
export default {
  name: "index",
  data() {
    let _this = this;
    return {
      tabs: [
        {label: _this.$t('About.notice'), tabName: 'notice',count: 0,},
        {label: _this.$t('System_Information'), tabName: 'messageSite',count: 0,},
      ],
    }
  },
  computed: {
    ...mapGetters(['userInfo','themeColor','agentRole']),
    isCustomerView(){
      return this.userInfo.custType == 3 || (this.userInfo.custType == 1 && this.agentRole == 'CUSTOMER');
    },
    tabsComputed(){
      if(this.isCustomerView){
        return this.tabs;
      }else {
        let fillterTabs = this.tabs.filter((item) => {
          return item.tabName == 'notice';
        })
        return fillterTabs;
      }
    },
  },
  mounted(){
    let reouterview = document.getElementById('routerview');
    reouterview.classList.add('no-padding-import');
    this.getPopUpCount();
    this.getMessageCount();
  },
  beforeDestroy(){
    let reouterview = document.getElementById('routerview');
    reouterview && reouterview.classList.remove('no-padding-import');
  },
  methods: {
    refreshPopUpCount(){
      this.getPopUpCount();
    },

    getPopUpCount(){
      this.$http({
        url: '/crm/reception/popUpNoticeList',
        method: 'get',
        params: {
          custId: this.userInfo.id,
          page: 0,
          size: 10,
          receiverType: this.isCustomerView ? 1: 2,
        },
        addToken:true,
      }).then((res) => {
        this.tabs[0].count = res.data.statistics.totalUnread;
      });
    },

    getMessageCount(){
      this.$http({
        url: '/crm/reception/notice',
        method: 'get',
        params: {
          custId: this.userInfo.id,
          page: 0,
          size: 10,
        },
        addToken:true,
      }).then((res) => {
        this.tabs[1].count = res.data.statistics.unreadNumber;
      });
    },

    tabHandle(item) {
      this.$router.push({name: item.tabName});
    },
    getCountStyle(item){
      return {
        backgroundColor: colorRgba(this.themeColor,0.1)
      }
    },
    readallMsg(){
      this.tabs[1].count = 0;
    },
    sendMsgCount(count){
      this.tabs[1].count = count;
    },
    sendPopUpCount(count){
      this.tabs[0].count = count;
    },
    readallPopUp(){
      this.tabs[0].count = 0;
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/variable";
.message-tag {
  height: 58px;
  position: relative;
  z-index: 99;
  background-color: #ffffff;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .tab-item {
    height: 100%;
    line-height: 58px;
    margin-left: 24px;
    cursor: pointer;
    &.on {
      color: $themeColor;
      border-bottom: 2px solid $themeColor;
    }
    .label {
      padding-right: 10px;
    }
    .count {
      padding: 1px 5px;
      color: $themeColor;
      border-radius: 10px;
      text-align: center;
    }

  }
}
.message-outer {
  padding: 24px;
  padding-bottom: 0;
  .message-inner {
    min-height: 400px;
    padding: 24px;
    padding-bottom: 0;
    background-color: #ffffff;
  }
}

</style>
<style lang="scss">
.message {
  .top-module {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
  }
  .message-list {
    .message-item {
      &.has-img {
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }
      border-bottom: 1px solid #EBE9F1;
      &:last-child {
        border-bottom: none;
      }
      margin-bottom: 16px;
      padding-bottom: 16px;
      .image-box {

        border-radius: 5px;
        margin-right: 10px;
        .img-el {
          width: 94px;
          height: 50px;
        }
      }
      .title {
        color: #6E6B7B;
      }
      .cicle {
        display: inline-block;
        margin-right: 5px;
        vertical-align: middle;
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background-color: #D85E5F;
      }
      .time {
        color: #B9B9C3;
      }
    }
  }
}
</style>
